const SHOW_TERMS = 'show_terms'

export default SHOW_TERMS